import { useEffect, useState } from "react";
import { capToBalance, draftToNumber } from "../../TradeForm/utils/format";
import { MIN_ORDER_COST_USDT } from "../../TradeForm/constants";
import { applyKeypadKey, KEYPAD_DELETE } from "../utils/keypad";

const formatWithDecimals = (value) => Number(value).toFixed(2);

export const useWagerKeypad = ({ wager, onWagerChange, availableBalance }) => {
  const initial =
    wager > 0 ? wager : capToBalance(MIN_ORDER_COST_USDT, availableBalance);
  const [draft, setDraft] = useState(formatWithDecimals(initial));
  // Armed on open: the first digit or "." replaces the whole value
  const [isOvertype, setIsOvertype] = useState(true);

  useEffect(() => {
    if (!(wager > 0) && initial > 0) onWagerChange(initial);
  }, []);

  const onKeyPress = (key) => {
    const next = applyKeypadKey(draft, key, { isOvertype });

    if (draftToNumber(next) > availableBalance) return;

    if (key !== KEYPAD_DELETE) setIsOvertype(false);
    setDraft(next);
    onWagerChange(draftToNumber(next));
  };

  const dismissOvertype = () => setIsOvertype(false);

  return { draft, isOvertype, onKeyPress, dismissOvertype };
};
